import styled from "styled-components";
interface IProps {
  color?: React.CSSProperties["color"];
  background?: React.CSSProperties["background"];
}
export const Styles = styled.div<IProps>`
  .ant-checkbox-disabled .ant-checkbox-inner {
    border-color: ${(props) =>
      props.color ? `${props.color} !important` : ""};
    &::after {
      border-color: ${(props) => (props.color ? props.color : "")};
    }
  }
  .ant-form-item-control {
    background: ${(props) =>
      props.background ? `${props.background} !important` : "#fff"};
    .ant-checkbox-disabled + span {
      color: ${(props) => (props.color ? props.color : "")};
    }
    justify-content: center;
    padding-inline: 5px;
  }
  .ant-checkbox + span {
    transform: translateY(0px);
  }
`;
